<template>
    <div class="upload-container">
        <h3>이미지 업로드</h3>
        <input type="file" @change="onFileChange" />
        <input
            v-model="uploadPassword"
            type="password"
            placeholder="업로드 비밀번호"
            autocomplete="current-password"
            @keyup.enter="uploadFile"
        />
        <button @click="uploadFile" :disabled="!selectedFile || !uploadPassword">업로드</button>

        <div v-if="uploadUrl">
            <p>업로드 완료! 파일 보기:</p>
            <img :src="uploadUrl" alt="업로드 이미지" style="max-width:300px;" />
        </div>

        <div v-if="fileList.length > 0">
            <h4>업로드된 파일 목록:</h4>
            <ul>
                <li v-for="(file, index) in fileList" :key="index">
                    <a :href="'/uploads/' + file" target="_blank">{{ file }}</a>
                </li>


            </ul>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    data() {
        return {
            selectedFile: null,
            uploadPassword: "",
            uploadUrl: null,
            fileList: [], // 파일 목록을 저장할 배열
        };
    },
    mounted() {
        this.fetchFileList(); // 컴포넌트가 마운트되면 파일 목록을 불러옵니다.
    },
    methods: {
        onFileChange(e) {
            this.selectedFile = e.target.files[0];
        },
        async uploadFile() {
            const formData = new FormData();
            formData.append("file", this.selectedFile);
            formData.append("password", this.uploadPassword);

            try {
                let url = this.$url + '/api/upload';

                const res = await axios.post(url, formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                });

                console.log(res.data.url);
                this.uploadUrl = res.data.url; // 서버에서 반환된 이미지 URL
                this.uploadPassword = "";
                this.fetchFileList(); // 파일 업로드 후 파일 목록 갱신

            } catch (err) {
                const message = err.response && err.response.data && err.response.data.error
                    ? err.response.data.error
                    : err;
                alert("업로드 실패: " + message);
            }
        },
        // 파일 목록을 서버에서 가져오는 메서드
        async fetchFileList() {
            try {
                let url = this.$url + '/api/files';
                const res = await axios.get(url);
                this.fileList = res.data; // 서버에서 가져온 파일 목록을 fileList에 저장
            } catch (err) {
                alert("파일 목록 조회 실패: " + err);
            }
        },
    },
};
</script>
